import React from "react";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  FormGrid,
  Field,
  TextField,
  SwitchField,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";
import PermissionMatrix from "../../components/Form/PermissionMatrix";

// A role is a named set of permissions; one role can be the default handed to
// new garage logins.
export default class RoleForm extends React.Component {
  constructor(props) {
    super(props);
    const role = props.item || {};
    this.state = {
      id: role.id || "",
      version: role.version,
      name: role.name || "",
      description: role.description || "",
      scopes: role.scopes || [],
      isGarageDefault: !!role.isGarageDefault,
      loading: false,
      error: "",
      errors: {},
    };
    this.engine = new RequestEngine();
  }

  validate() {
    const { name, scopes } = this.state;
    const errors = {};
    if (`${name}`.trim().length < 2) {
      errors.name = strings.name_min_hint;
    }
    if (!scopes || scopes.length === 0) {
      errors.scopes = strings.permissions_required_hint;
    }
    return errors;
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { id, version, name, description, scopes, isGarageDefault } =
      this.state;
    this.setState({ loading: true, error: "", errors: {} });

    const payload = {
      name: `${name}`.trim(),
      description: `${description}`.trim() || undefined,
      scopes,
      isGarageDefault,
    };

    try {
      const response = id
        ? await this.engine.updateItem("roles", id, { ...payload, version })
        : await this.engine.saveItem("roles", payload);

      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ loading: false });
        this.props.onSaved(response.data);
        return;
      }
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const {
      name,
      description,
      scopes,
      isGarageDefault,
      loading,
      error,
      errors,
    } = this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection title={strings.role} icon="nc-icon nc-badge">
          <FormGrid>
            <TextField
              label={strings.name}
              required
              value={name}
              onChange={(value) => this.setState({ name: value })}
              error={errors.name}
            />
            <TextField
              label={strings.description}
              value={description}
              onChange={(value) => this.setState({ description: value })}
            />
          </FormGrid>

          <SwitchField
            label={strings.default_for_garages}
            help={strings.default_for_garages_hint}
            checked={isGarageDefault}
            onChange={(checked) => this.setState({ isGarageDefault: checked })}
          />
        </FormSection>

        <FormSection title={strings.permissions} icon="nc-icon nc-key-25">
          <Field error={errors.scopes}>
            <PermissionMatrix
              value={scopes}
              onChange={(value) => this.setState({ scopes: value })}
            />
          </Field>
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
